import React, { useState } from 'react';
import './Signup.css'; // Import the CSS file for styles
import { useNavigate } from 'react-router-dom';
import Assets from '../../Assets/Assets';

function Signup() {
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        email: '',
        occupation: '',
        age: '',
        gender: '',
    });

    const [errors, setErrors] = useState({
        name: '',
        phone: '',
        email: '',
        occupation: '',
        age: '',
        gender: '',
    });

    const [loading, setLoading] = useState(false); // State for loading
    const NaviGate = useNavigate();

    const OtpPage = () => {
        NaviGate('/verify-otp');
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const validateForm = () => {
        let formErrors = {};
        let isValid = true;

        // Name validation
        if (!formData.name) {
            formErrors.name = 'Name is required.';
            isValid = false;
        }
        if (!formData.occupation) {
            formErrors.occupation = 'Occupation is required.';
            isValid = false;
        }

        // Phone validation (basic check for 10 digits)
        if (!formData.phone) {
            formErrors.phone = 'Phone number is required.';
            isValid = false;
        } else if (!/^\d{10}$/.test(formData.phone)) {
            formErrors.phone = 'Phone number must be 10 digits.';
            isValid = false;
        }

        // Email validation
        if (!formData.email) {
            formErrors.email = 'Email is required.';
            isValid = false;
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            formErrors.email = 'Email is invalid.';
            isValid = false;
        }

        // Age validation (must be a number and at least 18)
        if (!formData.age) {
            formErrors.age = 'Age is required.';
            isValid = false;
        } else if (isNaN(formData.age) || formData.age < 18) {
            formErrors.age = 'Age must be a number and at least 18.';
            isValid = false;
        }

        // Gender validation
        if (!formData.gender) {
            formErrors.gender = 'Gender is required.';
            isValid = false;
        }

        setErrors(formErrors);
        return isValid;
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // Validate form before sending the request
        if (!validateForm()) {
            return;
        }

        setLoading(true); // Set loading to true when submitting the form

        const myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');

        const raw = JSON.stringify(formData);

        const requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow',
        };

        fetch('https://api.libaonline.com/api/v1/user', requestOptions)
            .then((response) => response.json())
            .then((result) => {
                setLoading(false); // Stop loading after the response

                if (result?.status === 200) {
                    // 
                    console.log(result)
                    console.log(result?.data?.insertId)
                    sessionStorage.setItem("user_id", result?.data?.insertId)
                    OtpPage();
                }
            })
            .catch((error) => {
                console.error('API Error:', error);
                setLoading(false); // Stop loading in case of an error
            });
    };

    return (
        <div className='signup'>
            <div className='signup-container'>

                <div className='card' style={{ maxWidth: '800px', textAlign: 'start', padding: '50px' }}>
                    <div style={{ textAlign: "center" }}>
                        <img src={Assets?.Logo} style={{ width: "150px" }}></img>
                    </div>
                    <br />
                    <br />
                    <h2 className='signup-header'>Signup</h2>
                    <form onSubmit={handleSubmit} className='signup-form'>
                        <div className='row'>
                            <div className='col-lg-6'>
                                <input
                                    type='text'
                                    name='name'
                                    placeholder='Name'
                                    value={formData.name}
                                    onChange={handleChange}
                                    className='form-input'
                                    style={{ marginBottom: '0px' }}
                                />
                                {errors.name && <small className='error'>{errors.name}</small>}
                            </div>
                            <div className='col-lg-6'>
                                <input
                                    type='tel'
                                    name='phone'
                                    placeholder='Phone'
                                    value={formData.phone}
                                    onChange={handleChange}
                                    className='form-input'
                                    style={{ marginBottom: '0px' }}
                                />
                                {errors.phone && <small className='error'>{errors.phone}</small>}
                            </div>
                        </div>

                        <div className='row'>
                            <div className='col-lg-6'>
                                <input
                                    type='email'
                                    name='email'
                                    placeholder='Email'
                                    value={formData.email}
                                    onChange={handleChange}
                                    className='form-input'
                                    style={{ marginBottom: '0px' }}
                                />
                                {errors.email && <small className='error'>{errors.email}</small>}
                            </div>
                            <div className='col-lg-6'>
                                <input
                                    type='text'
                                    name='occupation'
                                    placeholder='Occupation'
                                    value={formData.occupation}
                                    onChange={handleChange}
                                    className='form-input'
                                    style={{ marginBottom: '0px' }}
                                />
                                {errors.occupation && <small className='error'>{errors.occupation}</small>}
                            </div>
                        </div>

                        <div className='row'>
                            <div className='col-lg-6'>
                                <input
                                    type='number'
                                    name='age'
                                    placeholder='Age'
                                    value={formData.age}
                                    onChange={handleChange}
                                    className='form-input'
                                    style={{ marginBottom: '0px' }}
                                />
                                {errors.age && <small className='error'>{errors.age}</small>}
                            </div>
                            <div className='col-lg-6'>
                                <select
                                    name='gender'
                                    value={formData.gender}
                                    onChange={handleChange}
                                    style={{ marginBottom: '0px' }}
                                    className='form-input'
                                >
                                    <option value=''>Select Gender</option>
                                    <option value='2'>Male</option>
                                    <option value='3'>Female</option>
                                    <option value='4'>Other</option>
                                </select>
                                {errors.gender && <small className='error'>{errors.gender}</small>}
                            </div>
                        </div>

                        <button type='submit' className='form-button' disabled={loading}>
                            {loading ? <span className='loader'></span> : 'Submit'}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default Signup;
